"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Copied = exports.Copy = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CopyToClipboard = _interopRequireDefault(require("../../hoc/Clipboard/CopyToClipboard"));

var _react = _interopRequireWildcard(require("react"));

var _Upload = _interopRequireDefault(require("../Icons/Upload"));

var _Check = _interopRequireDefault(require("../Icons/Check"));

var _ThemeComponent = _interopRequireDefault(require("../Theme/ThemeComponent"));

var _theming = require("../../theming");

var _themeContants = require("../../constants/themeContants");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CopyToClipboardComponent = function CopyToClipboardComponent(_ref) {
  var children = _ref.children,
      copyText = _ref.copyText;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      copied = _useState2[0],
      setCopied = _useState2[1];

  if (!copyText) {
    throw new Error("Copy text is required");
  }

  var handleClick = function handleClick(copy) {
    copy(copyText);
    setCopied(true);
    setTimeout(function () {
      setCopied(false);
    }, 1000);
  };

  return _react["default"].createElement(_CopyToClipboard["default"], {
    children: children
  }, function (_ref2) {
    var copy = _ref2.copy;
    return _react["default"].createElement(ClipboardWrapper, {
      onClick: function onClick() {
        handleClick(copy);
      }
    }, children, copied ? _react["default"].createElement(Copied, null) : _react["default"].createElement(Copy, null));
  });
};

CopyToClipboardComponent.themeProps = {
  wrapper: {
    name: "CopyToClipboardComponent_Wrapper",
    description: "CopyToClipboardComponent wrapper style",
    type: _themeContants.themePropTypes.style
  },
  icon: {
    name: "CopyToClipboardComponent_Icon_style",
    description: "Icon style",
    type: _themeContants.themePropTypes.style
  },
  copyComponent: {
    name: "CopyToClipboardComponent_CopyComponent",
    description: "Copy component",
    type: _themeContants.themePropTypes.component
  },
  copiedComponent: {
    name: "CopyToClipboardComponent_CopiedComponent",
    description: "Copied component",
    type: _themeContants.themePropTypes.component
  }
};

var ClipboardWrapper = _styledComponents["default"].button.withConfig({
  displayName: "CopyToClipboardComponent__ClipboardWrapper",
  componentId: "s1537q-0"
})(["&:hover{outline:none;}", ";"], (0, _theming.applyVariants)(CopyToClipboardComponent.themeProps.wrapper));

var CopiedComponent = function CopiedComponent(_ref3) {
  var props = _extends({}, _ref3);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: CopyToClipboardComponent.themeProps.copiedComponent,
    fallback: _Check["default"]
  }, props));
};

var CopyComponent = function CopyComponent(_ref4) {
  var props = _extends({}, _ref4);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: CopyToClipboardComponent.themeProps.copyComponent,
    fallback: _Upload["default"]
  }, props));
};

var Copy = (0, _styledComponents["default"])(CopyComponent).withConfig({
  displayName: "CopyToClipboardComponent__Copy",
  componentId: "s1537q-1"
})(["", ";"], (0, _theming.applyVariants)(CopyToClipboardComponent.themeProps.icon));
exports.Copy = Copy;
var Copied = (0, _styledComponents["default"])(CopiedComponent).withConfig({
  displayName: "CopyToClipboardComponent__Copied",
  componentId: "s1537q-2"
})(["", ";"], (0, _theming.applyVariants)(CopyToClipboardComponent.themeProps.icon));
exports.Copied = Copied;
CopyToClipboardComponent.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  copyText: _propTypes["default"].string.isRequired
};
var _default = CopyToClipboardComponent;
exports["default"] = _default;